import { render, staticRenderFns } from "./commission-withdraw.vue?vue&type=template&id=7bbc3a5b&"
import script from "./commission-withdraw.vue?vue&type=script&lang=js&"
export * from "./commission-withdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports